// src/api/escandalloApi.js
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const getEscandalloSubgrupos = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/api/vista-grupos-subgrupos`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const updateEscandalloSubgrupo = async (id, updatedData) => {
  const token = localStorage.getItem("token");
  const response = await axios.put(
    `${API_URL}/api/escandallo-subgrupo/${id}`,
    updatedData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const deleteEscandalloSubgrupo = async (id) => {
  const token = localStorage.getItem("token");
  const response = await axios.delete(
    `${API_URL}/api/escandallo-subgrupo/${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const getGrupos = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/api/vista-grupos`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};
